import { startOfWeek as startOfWeekBase } from 'date-fns'
import { getLocale } from './getLocale'

export function startOfWeek(date: Date) {
  return startOfWeekBase(date, { locale: getLocale(), weekStartsOn: 1 })
}
